module.exports = __webpack_public_path__ + "img/error-state.6f029552.svg";